export const ADMISSIONS_THREEJS_VISUALIZATION_PROMPT =
  "generate an advanced visualization of all admissions data using threejs";

export const TUITION_PRIOR_YEAR_VISUALIZATION_PROMPT =
  "Show me an advanced chart of the outstanding student tuition payments due this year, and layer over the prior year data";

const normalizePromptText = (value: string): string =>
  value.trim().toLowerCase().replace(/\s+/g, " ");

const TUITION_PRIOR_YEAR_VISUALIZATION_PATTERN =
  /(?=.*\b(tuition|payments?|outstanding|due)\b)(?=.*\b(prior|previous|last)\s+year|year[-\s]?over[-\s]?year)(?=.*\b(advanced\s+chart|advanced\s+visualization|3d|three(?:\.js|js)?|layer|overlay)\b)/i;

export const isTuitionPriorYearVisualizationPrompt = (
  question: string,
): boolean => {
  const normalized = normalizePromptText(question);
  return (
    normalized === normalizePromptText(TUITION_PRIOR_YEAR_VISUALIZATION_PROMPT)
    || TUITION_PRIOR_YEAR_VISUALIZATION_PATTERN.test(normalized)
  );
};
